export const RECEIVE_BANNERS = "adminBanner/RECEIVE_BANNERS";

export const SET_BANNER_EDITING = "adminBanner/SET_BANNER_EDITING";
export const EDIT_BANNER_PROP = "adminBanner/EDIT_BANNER_PROP";
export const UPDATE_BANNER = "adminBanner/UPDATE_BANNER";
export const DELETE_BANNER = "adminBanner/DELETE_BANNER";
export const REORDER_BANNERS = "adminBanner/REORDER_BANNERS";